import { f7 } from "framework7-react";
import { useSetRecoilState } from "recoil";
import AuthState from "../../atoms/AuthState";
import { loadUser, saveUser } from "./preferences";
import { isEqual } from "lodash";
import { saveLoginData, removeLoginData } from "../../utils/auth";
import useAuthenticate from "../../actions/Authenticate";
export default useCommon;

function useCommon() {
  const setAuthState = useSetRecoilState(AuthState);
  const { auth } = useAuthenticate();

  return {
    navigate,
    refresh_user,
  };

  async function refresh_user() {
    try {
      const res = await auth();

      if (res.status) {
        await saveUser(res.data);
        setAuthState((prev) => {
          if (isEqual(prev.user, res?.data)) {
            return prev;
          } else {
            return { ...prev, user: res?.data };
          }
        });
      } else {
      }
    } catch (error) {
      console.log("Error, can't refresh user, please contact customer service");
    }
  }


  function navigate(path, options = {}) {
    /* if path is -1,direct back to previous page */
    if (path.toString() === "-1") {
      f7.views.main.router.back();
      return;
    }

    const defaultOptions = {
      reloadCurrent: false,
      pushState: true,
      // openIn: "popup",
    };
    let mergedOptions;
    /* check use default options or just use options passed */
    if (options.noOption) {
      const { noOption, ...restOptions } = options;
      mergedOptions = { ...restOptions };
    } else {
      mergedOptions = { ...defaultOptions, ...options };
    }
    /* tab route list  */
    const tabRoutes = [
      "/",
      "/promotion/",
      "/deposit/",
      "/notification/",
      "/settings/",
    ];
    /* if path is not start with / or end with /, show error */
    if (!path.startsWith("/")) {
      console.error(
        "Invalid path format. Path should start and end with '/'. Example: /path/"
      );
      return;
    }

    /* if path is tab route, show tab */
    if (tabRoutes.includes(path)) {
      const tabId =
        path === "/" ? `#view-home` : `#view-${path.replace(/\//g, "")}`;
      f7.tab.show(tabId);
    } else {
      /* if path is not tab route, navigate to page */
      if (options.query) {
        const queryString = Object.entries(options.query)
          .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
          .join('&');
        const pathWithQuery = `${path}?${queryString}`;
        f7.views.main.router.navigate(pathWithQuery, mergedOptions);
      } else {
        f7.views.main.router.navigate(path, mergedOptions);
      }
    }
  }
}
